import { TextField, validators } from '@vst/beam';
import { ComponentProps, useMemo } from 'react';
import { NumericFormatProps as NumberFormatProps } from 'react-number-format';

interface ZipCodeFieldProps
  extends Omit<NumberFormatProps<ComponentProps<typeof TextField>>, 'defaultValue' | 'value'> {
  value?: string;
  validation?: {
    required: string;
    invalid: string;
    regex: RegExp;
  };
}

const ZipCodeFieldInput = (props: ZipCodeFieldProps) => {
  const { validation, ...textFieldProps } = props;

  const validationRules = useMemo(() => {
    const validationRules = [];
    if (validation?.required) {
      validationRules.push(validators.required({ message: validation.required }));
    }
    if (validation?.invalid) {
      validationRules.push(validators.pattern({ pattern: validation.regex, message: validation.invalid }));
    }
    return validationRules;
  }, [validation]);

  return (
    <TextField
      data-testid={textFieldProps.name}
      validationRules={validationRules}
      labelProps={{ showStar: false, labelText: textFieldProps.labelProps?.labelText }}
      {...textFieldProps}
    />
  );
};

export default ZipCodeFieldInput;
